import styled, { css } from 'styled-components';

import { getPurpurColor, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const HtmlContentContainer = styled.div<{ $negative: boolean }>`
    ${({ $negative }) =>
        $negative &&
        css`
            color: ${getPurpurColor('textDefaultNegative')};
        `}

    > * {
        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    ul {
        list-style-type: disc;
    }

    ol {
        list-style-type: decimal;
    }

    ul,
    ol {
        margin-top: 1rem;
        margin-bottom: 1rem;
        padding-left: 2.5rem;

        > li {
            &:not(:first-child) {
                margin-top: 0.3125rem;
            }

            &:empty {
                display: none;
            }
        }
    }

    p {
        margin-top: 1rem;
        margin-bottom: 1rem;

        &:first-child {
            margin-top: 0;
        }
        &:last-child {
            margin-bottom: 0;
        }
    }

    a {
        background-color: transparent;
        color: inherit;
        transition:
            background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out,
            color 0.15s ease-in-out;
        text-decoration: underline;

        &:hover {
            color: ${getPurpurColor('purple500')};
            text-decoration: none;
        }
        &:hover,
        &:focus,
        &:active {
            text-decoration: none;
        }
        &:hover,
        &:active {
            outline: 0;
        }
    }

    .alert a {
        color: inherit;
        text-decoration: underline;

        &:hover {
            color: inherit;
            text-decoration: none;
        }

        &:focus {
            outline-color: ${getPurpurColor('functionalWhite')};
        }

        &.btn {
            text-decoration: inherit;
        }
    }

    img {
        max-width: 100%;
    }

    iframe[src*='youtube'] {
        height: 19.6875rem;
    }

    ${purpurMedia('lg')`
        iframe[src*='youtube'] {
            width: 48.375rem;
            height: 27.1875rem;
        }
    `}
`;
